import { observer } from "mobx-react-lite";
import { Marker } from "react-map-gl";
import { useMapMarkerStore } from "..";
import { GeoCoordinate } from "../interfaces/GeoCoordinate";

function MapMarker() {
    const mapMarkerStore = useMapMarkerStore();

    if (!mapMarkerStore.coordinates)
        return null;

    return (
        <Marker
            latitude={mapMarkerStore.coordinates.latitude}
            longitude={mapMarkerStore.coordinates.longitude}
            onDrag={e => mapMarkerStore.draw(new GeoCoordinate(e.lngLat.lat, e.lngLat.lng))}
            draggable={true}
            color="#105491"
        />
    );
}

export default observer(MapMarker);